import AppErrorBoundary from "components/Common/AppErrorBoundary";
import Loader from "components/Common/Loader";
import Floater from "components/Floater";
import i18n from "helpers/i18n";
import { Suspense } from "react";
import { I18nextProvider } from "react-i18next";
import { Outlet } from "react-router-dom";

const Auth = () => {
  return (
    <AppErrorBoundary scope="Auth">
      <Suspense fallback={<Loader open />}>
        <I18nextProvider i18n={i18n}>
          <Outlet />
          <Floater shouldShowFloater={true} />
        </I18nextProvider>
      </Suspense>
    </AppErrorBoundary>
  );
};

export default Auth;
